import { ART } from "../assets";
import { Phone } from "lucide-react";
import { CITIES, cityPath } from "../lib/cities";
import { SERVICES_PAGES, servicePath } from "../lib/services";

const PHONE = "617-717-9852";
const PHONE_HREF = "tel:+16177179852";

export default function Footer({ onStart }) {
  const serviceLinks = [
    ...SERVICES_PAGES.map((s) => ({ label: s.label, href: servicePath(s) })),
    { label: "Junk removal cost guide", href: "/junk-removal-cost" },
  ];
  const cols = [
    { title: "Services", links: serviceLinks },
    { title: "Company", links: [{ label: "How it works", href: "/#how" }, { label: "Pricing", href: "/junk-removal-cost" }, { label: "Areas served", href: "/#areas" }, { label: `Call ${PHONE}`, href: PHONE_HREF }] },
    { title: "Trust", links: [{ label: "Licensed & insured", href: "/#top" }, { label: "Donation-first", href: "/services/donation-pickup" }, { label: "Reviews", href: "/#top" }, { label: "FAQ", href: "/#top" }] },
  ];

  return (
    <footer className="px-5 pb-8 sm:px-8">
      <div className="mx-auto max-w-7xl rounded-[2.5rem] bg-charcoal px-7 py-14 sm:px-14 sm:py-16 text-canvas">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="font-logo font-semibold text-4xl lowercase text-white">
              milla
            </span>
            <p className="mt-5 max-w-xs text-lg text-canvas/60">
              Helping homeowners reclaim their homes — one photo, one room, one fresh start at a time.
            </p>
            <button
              onClick={onStart}
              data-testid="footer-cta"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-violet px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-violet-deep hover:-translate-y-0.5"
            >
              Get an instant quote
            </button>
            <p className="mt-7 text-sm font-semibold uppercase tracking-wide text-canvas/40">Prefer to call?</p>
            <a
              href={PHONE_HREF}
              data-testid="footer-phone"
              className="mt-2 inline-flex items-center gap-2.5 font-display text-2xl text-canvas transition-colors hover:text-lavender"
            >
              <Phone size={20} className="text-lavender" /> {PHONE}
            </a>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="text-sm font-semibold uppercase tracking-wide text-canvas/40">{c.title}</p>
                <ul className="mt-4 space-y-3">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="text-canvas/70 transition-colors hover:text-lavender"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-7">
          <p className="text-sm font-semibold uppercase tracking-wide text-canvas/40">Areas we serve</p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {CITIES.map((c) => (
              <a key={c.slug} href={cityPath(c)} className="text-sm text-canvas/50 transition-colors hover:text-lavender">
                {c.name}, {c.abbr}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-canvas/45">© {new Date().getFullYear()} milla. Get your space back.</p>
          <div className="flex gap-6 text-sm text-canvas/45">
            <a href="#top" className="hover:text-lavender">Privacy</a>
            <a href="#top" className="hover:text-lavender">Terms</a>
            <a href="#top" className="hover:text-lavender">Donation policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
